import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Rechtliche Informationen", -1)
const _hoisted_3 = {
  key: 0,
  class: "pt-2"
}
const _hoisted_4 = {
  key: 1,
  class: "pt-2"
}
const _hoisted_5 = {
  key: 2,
  class: "text-color--medium-emphasis"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Stand:", -1)
const _hoisted_7 = {
  key: 3,
  class: "text-color--medium-emphasis pb-2"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Stand:", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" DD. MMM YYYY ")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.heading)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_ctx.heading), 1))
      : (_openBlock(), _createElementBlock("h1", _hoisted_4, "Placeholder")),
    (_ctx.stand)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_ctx.moment(new Date()).format("DD.MMM YYYY")), 1)
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_7, _hoisted_10))
  ]))
}